import { frontHost } from '~/utils/host';

const revalidateCache = async (): Promise<void> => {
  try {
    const { proto, host } = await frontHost();
    const API_URL = `${proto}://${host}/makeapayment/api/revalidate`;
    const response = await fetch(API_URL, { method: 'GET' });

    if (!response.ok) {
      console.error(
        `Error: Failed to revalidate cache. Status code: ${response.status}`,
      );
    }

    console.log('Cache successfully revalidated.');
  } catch (error) {
    console.error('Error revalidating cache:', error);
  }
};

export default revalidateCache;
